
import ListDoctors from 'components/ListDoctors';

export default class Doctors extends ListDoctors {

    checkFilterdItems(items) {
        const { activeId } = this.props;

        if (!activeId)
            return items;

        const newItems = [...items];

        const index = newItems.findIndex(it => it.id === activeId);
        if (index > 0) {
            const it = newItems.splice(index, 1);
            newItems.unshift(it[0]);
        }

        return newItems;
    }

    customFilter(it, { isCurrent, dateSchedules }) {
        const req = isCurrent ? !!dateSchedules.find(sh => sh.doctorId === it.id) : true;
        return req;
    }

}
